const overloading = {
  breakpointNames: ['sm', 'md', 'lg', 'xl', 'xxl'],
  breakpoints: [576, 768, 992, 1200, 1600]
}

const colors = {
  colorGreen : '#118844',
  colorPurple : '#984299',
  colorLightPurple : '#B77AB7',
  colorDarkGrey : '#272727',
  colorGrey : '#EEEBEB'
}

const variables = {
  familyBase: '"proxima-nova",sans-serif',
  familyHeader: '"proxima-nova",serif',

  primaryColor: colors.colorPurple,
  fontColor: colors.colorDarkGrey,
  bgColor: '#ebebeb',

  ...colors,
  ...overloading
}

export default variables;